import { render } from "./Loading.vue?vue&type=template&id=df46cd04&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=df46cd04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df46cd04"

export default script